import type { ColumnQualityApiParams } from '@/entities/quality/api/getColumnQualityData';
import type { DataZoneRowCountApiParams } from '@/entities/quality/api/getDataZoneRowCount';
import type { QualityTrendApiParams } from '@/entities/quality/api/getQualityTrend';
import type { StatsTablesApiParams } from '@/entities/quality/api/getStatsTables';
import type { TableQualityApiParams } from '@/entities/quality/api/getTableQualityData';

/**
 * @description 품질 관련 쿼리 키 모음
 * columnQuality: 컬럼 품질 데이터 조회 키
 * tableQuality: 테이블 품질 데이터 조회 키
 * dataZoneRowCount: 데이터존별 Row Count 조회 키
 * qualityTrend: 품질 트렌드 조회 키
 * statsTables: 통계 테이블 목록 조회 키
 * qualityFilterOptions: 품질 필터 옵션 조회 키
 */

export const qualityKeys = {
  all: ['quality'] as const,
  columnQuality: (params: ColumnQualityApiParams) => [...qualityKeys.all, 'columnQuality', params] as const,
  tableQuality: (params: TableQualityApiParams) => [...qualityKeys.all, 'tableQuality', params] as const,
  dataZoneRowCount: (params: DataZoneRowCountApiParams) => [...qualityKeys.all, 'dataZoneRowCount', params] as const,
  qualityTrend: (params: QualityTrendApiParams) => [...qualityKeys.all, 'qualityTrend', params] as const,
  statsTables: (params: StatsTablesApiParams) => [...qualityKeys.all, 'statsTables', params] as const,
  qualityFilterOptions: () => [...qualityKeys.all, 'qualityFilterOptions'] as const,
} as const;
